<template>
    <div class="action_enforce">
        <div v-show="type == 'action_enforce'" class="top-tip">
            {{$t('flowComponent.enforceTip1')}}
        </div>
        <div v-show="type == 'action_random_jump'" class="top-tip">
            {{$t('flowComponent.enforceTip2')}}
        </div>
        <div class="goto-list">
            <div
                v-for="(cell, index) in unit.content.gotoList"
                :key="index"
                class="jump-cell"
            >
                <div class="jump-cell-l">
                    <div class="left-select">
                        <el-select
                            style="width: 120px"
                            v-model="cell.scope"
                            size="small"
                            @change="jumpTypeValueChange($event, index)"
                            :placeholder="$t('common.selectPlaceholder')"
                        >
                            <el-option
                                v-for="item in filterJumpTypeOptions(
                                    jumpTypeOptions
                                )"
                                :key="item.value"
                                :label="$t('common.' + item.value)"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </div>

                    <div class="right-select select-cell-sub-content-aft" ref="selectCellSubContentAftWidth">
                        <!-- <el-select
                            v-show="cell.scope === 'NODE'"
                            v-model="cell.value"
                            @change="nodeSelectChange"
                            :popper-append-to-body="false"
                            filterable
                            size="small"
                            placeholder="请输入或选择节点名称"
                        >
                            <el-option
                                v-for="item in nodeOptions"
                                :popper-class="
                                    'pop_my' + item.classPop + item.parentNum
                                "
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select> -->
                        <SelectAddnode
                            v-if="cell.scope === 'NODE'"
                            :nodeOptions="nodeOptions"
                            :nodeId="cell.value"
                            :defaultParentNodeId="nodeId"
                            :nodeSelectARef="`actionEnforceAddnode_${com_index}_${index}`"
                            :intentId="intentId"
                            @getNodeOptions="getNodeOptions"
                            @setAddNodeId="setAddNodeId"
                            :index="index"
                        ></SelectAddnode>
                        <el-cascader
                            v-if="!isBotLink"
                            filterable
                            v-show="cell.scope === 'INTENT'"
                            v-model="cell.value"
                            placeholder="请选择意图"
                            size="small"
                            :options="intentTree4Radio"
                            :props="{
                                emitPath: false,
                                label: 'name',
                                value: 'id',
                            }"
                        ></el-cascader>
                        <template v-else>
                            <el-popover
                                ref="action_enforce_popover"
                                placement="bottom"
                                :width="intentSelectAndSearchPoperWidth"
                                trigger="click"
                                popper-class="set-welcome-message-search-intent-poprver"
                                :visible-arrow="false"
                                @show="showPover(cell)">
                                <el-input
                                    class="search-intent-input"
                                    size="small"
                                    :placeholder="$t('flowComponent.searchOrSelectIntent')"
                                    v-model="cell.valueText"
                                    slot="reference"
                                    @input="inputFn($event,cell.valueText)">
                                    <i slot="suffix" class="el-icon-arrow-down"></i>
                                </el-input>
                                <el-tree
                                    class="choose-intent-tree"
                                    :style="{width: intentSelectAndSearchPoperWidth + 'px'}"
                                    :data="intentTree4Radio"
                                    :props="{
                                        children: 'children',
                                        label: 'name',
                                        id:'id',
                                        isLeaf: 'isLeafNode',
                                    }"
                                    :filter-node-method="filterNode"
                                    node-key="id"
                                    ref="tree">
                                    <span :class="['custom-tree-node',  data.id.indexOf('B') === -1 && data.id.indexOf('S') === -1 && data.id.indexOf('T') === -1  ? '' : 'disabled']" slot-scope="{node,data}"   @click="onNodeClick(data,node,cell)">
                                        <span class="custom-tree-node-left">
                                            <span :class="['data-label']">{{ data.name }}</span>
                                        </span>
                                        <i class="el-icon-check" v-if="data.checked"></i>
                                    </span>
                                </el-tree>
                            </el-popover>
                        </template>
                    </div>
                </div>

                <span
                    v-if="index == 0"
                    class="el-icon-plus-box"
                    @click="addGoto"
                >
                    <i class="el-icon-plus"></i>
                </span>
                <span
                    v-if="index !== 0"
                    class="el-icon-delete-box"
                    @click="deleteGoto(index)"
                    ><i class="el-icon-close"></i
                ></span>
            </div>
        </div>
    </div>
</template>
<script>
import SelectAddnode from "./../cell/SelectAddnode.vue";
export default {
    components: { SelectAddnode },
    props: [
        "unit",
        "intentOptions",
        "nodeOptions",
        "intentTree4Radio",
        "type",
        "isStartOrEnd",
        "intentId",
        "nodeId",
        "com_index",
        "isBotLink"
    ],
    data() {
        return {
            jumpTypeOptions: [
                {
                    value: "NODE",
                    label: "跳转到节点",
                },
                {
                    value: "INTENT",
                    label: "跳转到意图",
                },
            ],
            // unit: {
            //     conditionList: [],
            //     content: {
            //         gotoList: [
            //             {
            //                 scope: "NODE", // INTENT NODE
            //                 value: "",
            //             },
            //         ],
            //     },
            //     type: "action_enforce",
            // },
            isCheck:true,
            intentSelectAndSearchPoperWidth: 300,
        };
    },
    methods: {
        getNodeOptions() {
            this.$emit("getNodeOptions", true);
        },
        setAddNodeId(nodeId, index) {
            console.log(nodeId, index);
            this.$set(this.unit.content.gotoList[index], "value", nodeId);
        },
        filterJumpTypeOptions(value) {
            if (this.isStartOrEnd) {
                return [
                    {
                        value: "INTENT",
                        label: "跳转到意图",
                    },
                ];
            } else {
                return value;
            }
        },
        jumpTypeValueChange(e, index) {
            console.log(e, index);
            this.unit.content.gotoList[index].value = "";
        },
        addGoto() {
            if (this.isStartOrEnd) {
                this.unit.content.gotoList.push({
                    scope: "INTENT", // INTENT NODE
                    value: "",
                });
            } else {
                this.unit.content.gotoList.push({
                    scope: "NODE", // INTENT NODE
                    value: "",
                });
            }
        },
        deleteGoto(index) {
            this.unit.content.gotoList.splice(index, 1);
        },
        inputFn(val,item){
            this.$refs.tree[0].filter(val);
            this.$forceUpdate()
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        onNodeClick(data,node,item){
            if(data.id.indexOf('B') > -1 || data.id.indexOf('S') > -1 || data.id.indexOf('T') > -1 ) return false;
            this.$set(item,'valueText',data.name);
            this.$set(item,'value',data.id)
            this.$set(data,'checked',true)
            this.$refs['action_enforce_popover'][0].doClose()
        },
        showPover(data){
            // 为poper设置宽度
            if (this.$refs.selectCellSubContentAftWidth[0]) {
                this.intentSelectAndSearchPoperWidth = window.getComputedStyle(this.$refs.selectCellSubContentAftWidth[0]).width;
                if (
                    this.intentSelectAndSearchPoperWidth.indexOf("px") > -1
                ) {
                    this.intentSelectAndSearchPoperWidth =
                        this.intentSelectAndSearchPoperWidth.replace("px", "") - 30;
                } else {
                    this.intentSelectAndSearchPoperWidth = 300;
                }
            } else {
                this.intentSelectAndSearchPoperWidth = 300;
            }


            let list = JSON.parse(JSON.stringify(this.intentTree4Radio))
            list.forEach(botItem => {
                botItem.children.forEach(skillItem => {
                    skillItem.children.forEach(typeItem => {
                        typeItem.children.forEach(intentItem => {
                            intentItem.checked = false;
                            if(data.value == intentItem.id){
                                intentItem.checked = true;
                            } 
                        })
                    })
                })
            })
            this.intentTree4Radio =  JSON.parse(JSON.stringify(list))
        },
    },
};
</script>
<style lang="less" scoped>
.choose-intent-tree {
    max-height: 150px;
    overflow-x: hidden;
    overflow-y: auto;
}
.action_enforce {
    .top-tip {
        background-color: #fff8f4;
        border-radius: 5px;
        padding: 8px;
        text-align: left;
        color: #ff9555;
        font-size: 12px;
    }
    .goto-list {
        margin-top: 8px;
        .jump-cell {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 4px;
            .jump-cell-l {
                flex: auto;
                border: 1px solid #e0e6f7;
                border-radius: 5px;
                display: flex;
                justify-content: flex-start;
                /deep/.inline-input {
                    width: 100%;
                    padding-right: 0;
                }
                /deep/.el-cascader {
                    width: 100%;
                    padding-right: 0;
                }
                /deep/.el-input__inner {
                    border: none;
                    padding-right: 0;
                }
                /deep/.el-input__suffix {
                    display: none;
                }
            }
            .left-select {
                flex: none;
                width: 120px;
                .el-select {
                    width: 100%;
                }
            }
            .right-select {
                margin-left: 16px;
                flex: auto;
                &.el-select {
                    width: 100%;
                }
                &.el-cascader {
                    width: 100%;
                }
            }
            .el-icon-plus-box {
                color: white;
                width: 29px;
                height: 29px;
                line-height: 29px;
                background: #366aff;
                border-radius: 5px;
                margin-left: 14px;
                text-align: center;
                i {
                    font-size: 14px;
                    font-weight: 800;
                }
            }
            .el-icon-delete-box {
                margin-left: 14px;
                width: 27px;
                height: 27px;
                line-height: 27px;
                background: #ffffff;
                border: 1px solid #e0e6f7;
                border-radius: 5px;
                color: #366aff;
                i {
                    font-size: 14px;
                    font-weight: 800;
                }
            }
        }
    }
}
</style>